export default class MobMenu{
  constructor(elem) {

    var tmp_closer =  '<div id="mobile-menu-close" class="close-trigger">'+
                      ' <i class="icon icon-close"></i>'+
                      '</div>';
    this.closer   = document.createElement("div");
    this.closer.innerHTML = tmp_closer;
    this.menu     = document.getElementById(elem);
    this.trigger  = document.getElementById(elem+"-trigger");

    if(this.menu && this.trigger){
      this.menu.appendChild(this.closer);

      // uso arrow function per non cambiare this
      this.trigger.onclick    = () => this.toggle();
      this.closer.onclick     = () => this.toggle();
    }
  }

  toggle(){
    document.body.classList.toggle('show-menu-mobile')
    this.menu.classList.toggle('hide');
    setTimeout(() => this.menu.classList.toggle('menu-animation'), 100);
  }
}


// WEBPACK FOOTER //
// ./scripts/util/MobMenu.js